import { useAuthStore } from "@src/features/auth/auth-store";
import { useIsSupportUser } from "@src/features/tenants";
import { inheritedAccessReason, type InheritedAccessReason } from "../utils/inherited-access-reason";

/**
 * Whether the signed-in user's access comes from the support role or a
 * Microsoft group, which stored-grant recipients (notifications, report
 * emails) never include. `null` when it doesn't.
 */
export function useInheritedAccessReason(): InheritedAccessReason | null {
  const accessToken = useAuthStore((state) => state.accessToken);
  const isSupportUser = useIsSupportUser();
  return inheritedAccessReason(isSupportUser, accessToken);
}
